<template>
    <div class="cms_fullwidth_lane">
        <GrcDB ref="GRCDB"></GrcDB>
        <div class="cms_maincont_lane" v-html="account_data" />
        
        
    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'

export default {
  name: 'frmteszt_accountdata',
  components: {
    GrcDB,
  },
  props: {
    cms_menuname: String
  },

  data () {
        return {
            account_data: "",
        }
  },
  model: {

  },  
  methods:{

    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_account_data", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }


        this.account_data = Q.DATA[0].account_data;

    },

  },
  created()
  {
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
